/*
 * moment.js language configuration
 * language : russian (ru)
 * author : Viktorminator : https://github.com/Viktorminator
 */

var pluralRules = [
  function (n) {
    return n % 10 === 1 && n % 100 !== 11;
  },
  function (n) {
    return n % 10 >= 2 && n % 10 <= 4 && n % 10 % 1 === 0 && (n % 100 < 12 || n % 100 > 14);
  },
  function (n) {
    // eslint-disable-next-line max-len
    return n % 10 === 0 || n % 10 >= 5 && n % 10 <= 9 && n % 10 % 1 === 0 || n % 100 >= 11 && n % 100 <= 14 && n % 100 % 1 === 0;
  },
  function () {
    return true;
  }
];

function plural (word, num) {
  var forms = word.split('_');
  var minCount = Math.min(pluralRules.length, forms.length);
  var i = -1;

  while (++i < minCount) {
    if (pluralRules[i](num)) {
      return forms[i];
    }
  }
  return forms[minCount - 1];
}

export function relativeTimeWithPlural (number, withoutSuffix, key, withoutNumber) {
  var format = {
    mm: 'Минута_Минуты_Минут_Минуты',
    hh: 'Час_Часа_Часов_Часа',
    dd: 'День_Дня_Дней_Дня',
    MM: 'Месяц_Месяца_Месяцев_Месяца',
    yy: 'Год_Года_Лет_Года'
  };
  if (key === 'm') {
    return withoutSuffix ? 'Минута' : 'Минуту';
  }

  if (withoutNumber) {
    return plural(format[key], Number(number));
  }

  return `${number} ${plural(format[key], Number(number))}`;

}

function monthsCaseReplace (m, format) {
  var months = {
    nominative: 'Январь_Февраль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь'.split('_'),
    accusative: 'Января_Февраля_Марта_Апреля_Мая_Июня_Июля_Августа_Сентября_Октября_Ноября_Декабря'.split('_')
  };

  var nounCase = (/D[oD]? *MMMM?/).test(format)
    ? 'accusative'
    : 'nominative';

  return months[nounCase][m.month()];
}

function weekdaysCaseReplace (m, format) {
  var weekdays = {
    nominative: 'Воскресенье_Понедельник_Вторник_Среда_Четверг_Пятница_Суббота'.split('_'),
    accusative: 'Воскресенье_Понедельник_Вторник_Среду_Четверг_Пятницу_Субботу'.split('_')
  };

  var nounCase = (/\[ ?[Вв] ?(?:прошлую|следующую)? ?\] ?dddd/).test(format)
    ? 'accusative'
    : 'nominative';

  return weekdays[nounCase][m.day()];
}

require('moment').lang('ru', {
  months: monthsCaseReplace,
  monthsShort: 'Янв_Фев_Мар_Апр_Май_Июн_Июл_Авг_Сен_Окт_Ноя_Дек'.split('_'),
  weekdays: weekdaysCaseReplace,
  weekdaysShort: 'Вск_Пнд_Втр_Срд_Чтв_Птн_Сбт'.split('_'),
  weekdaysMin: 'Вс_Пн_Вт_Ср_Чт_Пт_Сб'.split('_'),
  longDateFormat: {
    LT: 'HH:mm',
    L: 'DD.MM.YYYY',
    LL: 'D MMMM YYYY г.',
    LLL: 'D MMMM YYYY г., LT',
    LLLL: 'dddd, D MMMM YYYY г., LT'
  },
  calendar: {
    sameDay: '[Сегодня в] LT',
    nextDay: '[Завтра в] LT',
    lastDay: '[Вчера в] LT',
    nextWeek () {
      return this.day() === 2 ? '[Во] dddd [в] LT' : '[В] dddd [в] LT';
    },
    lastWeek () {
      // eslint-disable-next-line default-case
      switch (this.day()) {
      case 0:
        return '[В прошлое] dddd [в] LT';
      case 1:
      case 2:
      case 4:
        return '[В прошлый] dddd [в] LT';
      case 3:
      case 5:
      case 6:
        return '[В прошлую] dddd [в] LT';
      }
    },
    sameElse: 'L'
  },

  // It needs checking (adding) russian plurals and cases.
  relativeTime: {
    future: 'через %s',
    past: '%s назад',
    s: 'несколько секунд',
    m: relativeTimeWithPlural,
    mm: relativeTimeWithPlural,
    h: 'час',
    hh: relativeTimeWithPlural,
    d: 'день',
    dd: relativeTimeWithPlural,
    M: 'месяц',
    MM: relativeTimeWithPlural,
    y: 'год',
    yy: relativeTimeWithPlural
  },
  ordinal: '%d.',
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 7 // The week that contains Jan 1st is the first week of the year.
  }
});
